import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AIOutlineButton } from '../ui/AIOutlineButton';
interface RedemptionsChartProps {
  data: {
    date: string;
    redemptions: number;
  }[];
  onAIClick?: () => void;
}
const RedemptionsChart: React.FC<RedemptionsChartProps> = ({
  data,
  onAIClick
}) => {
  return <div className="rounded-lg border border-gray-200 bg-white p-6" data-id="element-362">
      <div className="flex items-center justify-between mb-4" data-id="element-363">
        <h3 className="text-lg font-semibold" data-id="element-364">Riscatti nel Tempo</h3>
        <AIOutlineButton onClick={onAIClick} title="AI Insights" data-id="element-365">
          Suggerimenti AI
        </AIOutlineButton>
      </div>
      <div className="h-64" data-id="element-366">
        <ResponsiveContainer width="100%" height="100%" data-id="element-367">
          <LineChart data={data} margin={{
          top: 5,
          right: 10,
          left: 0,
          bottom: 5
        }} data-id="element-368">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-369" />
            <XAxis dataKey="date" stroke="#6B7280" fontSize={12} data-id="element-370" />
            <YAxis stroke="#6B7280" fontSize={12} data-id="element-371" />
            <Tooltip contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem'
          }} formatter={(value: number) => [value, 'Riscatti']} labelFormatter={label => `Data: ${label}`} data-id="element-372" />
            <Line type="monotone" dataKey="redemptions" stroke="#108d3e" strokeWidth={2} dot={{
            fill: '#108d3e',
            r: 4
          }} data-id="element-373" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>;
};
export default RedemptionsChart;